import React from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NavBarContainer, NavBarTitle } from 'common/NavBar';
import ScheduleCalendar from 'components/ScheduleCalendar/ScheduleCalendar';
import { LoggedEmployee } from 'store/employee/interfaces';
import { useGetLoggedEmployeeQuery } from 'store/employee/employees';
import useScheduleCalendarContext from 'components/ScheduleCalendar/context/useScheduleCalendarContext';
import getFilterDates from 'components/ScheduleCalendar/getFilterDates';
import useOrganizationStartWeekDay from 'hooks/useOrganizationStartWeekDay';
import { useGetWorkingHoursQuery } from 'store/workingHours/workingHours';
import ContentSuspense from 'common/ContentSuspense/ContentSuspense';
import getEarliestScheduleShift from 'components/ScheduleCalendar/getEarliestScheduleShift';

export default function ScheduleTracking() {
  const { t } = useTranslation();
  const { data: currentEmployee = {} as LoggedEmployee } =
    useGetLoggedEmployeeQuery();
  const { scheduleRanges, currentDate } = useScheduleCalendarContext();

  const startWeekDay = useOrganizationStartWeekDay();
  const { dateBefore, dateAfter } = getFilterDates({
    startWeekDay,
    currentDate,
  });

  const {
    data: workingHours = [],
    isLoading: workingHoursFetching,
    isError: workingHoursFetchError,
  } = useGetWorkingHoursQuery({
    employee: [currentEmployee.id.toString()],
    'date[after]': dateAfter,
    'date[before]': dateBefore,
  });

  const earliestScheduleShift = getEarliestScheduleShift(scheduleRanges);

  return (
    <Grid item xs={10} bgcolor="background.list">
      <NavBarContainer>
        <NavBarTitle>{t('menu.project_tracking')}</NavBarTitle>
      </NavBarContainer>
      <ContentSuspense
        isLoading={workingHoursFetching}
        isError={workingHoursFetchError}
      >
        <ScheduleCalendar
          workingHours={workingHours}
          earliestScheduleShift={earliestScheduleShift}
        />
      </ContentSuspense>
    </Grid>
  );
}
